import React, { useContext } from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import TouchableOpacity from '../components/TouchableOpacity';
import { useAppSelector } from '../app/hooks';
import getThemeLookup from '../selectors/getThemeLookup';
import { HeaderBarThemeKeyContext } from './HeaderBar';
import combineStyles from '../utils/combineStyles';

const Hamburger = ({ onClick }: { onClick: () => void }) => {
  const p = useAppSelector(getThemeLookup);
  const headerBarThemeKey = useContext(HeaderBarThemeKeyContext);

  return (
    <TouchableOpacity onClick={onClick}>
      <GiHamburgerMenu
        style={combineStyles(
          p('headerHamburgerButton', ['fontSize', 'color']),
          p(`${headerBarThemeKey}headerHamburgerButton`, ['fontSize', 'color']),
        )}
      />
    </TouchableOpacity>
  );
};

export default Hamburger;
